/* eslint-disable react/no-array-index-key */
import { Button, Spinner, Tooltip } from '@nextui-org/react';
import React from 'react';
import { FaDownload } from 'react-icons/fa';
import DatepickerInput from '../../components/DatepickerInput/DatepickerInput';
import { formatarData } from '../../util/format';
import { converterEbaixarXLSX } from '../../util/XSLSFactory';
import DragDrop from './components/DragDrop/DragDrop';
import OrderListTable from './components/OrderListTable/OrderListTable';
import useListNotfis from './hooks/useListNotfis';

const Pedidos = (): JSX.Element => {
  const { loading, pedidos, control, endDate, startDate, consultarPedidos } =
    useListNotfis();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row items-center justify-between">
        {/* Date Filter */}
        <div className="flex flex-row gap-4">
          <DatepickerInput
            control={control}
            name="startDate"
            datePickerProps={{
              selectsStart: true,
              startDate,
              endDate,
            }}
            inputProps={{
              size: 'md',
              label: 'De',
              variant: 'underlined',
            }}
          />

          <DatepickerInput
            control={control}
            name="endDate"
            datePickerProps={{
              selectsEnd: true,
              startDate,
              endDate,
              minDate: startDate,
            }}
            inputProps={{
              size: 'md',
              label: 'até',
              variant: 'underlined',
            }}
          />
        </div>

        <DragDrop callback={() => consultarPedidos()} />
      </div>
      <Tooltip content={<p>Realizar download da planilha</p>}>
        <Button
          type="button"
          color="warning"
          isIconOnly
          onPress={() =>
            converterEbaixarXLSX(
              pedidos,
              `${formatarData(new Date(), false, 'normal')}-NOTFIS.xlsx`
            )
          }
        >
          <FaDownload className="h-6 w-6 cursor-pointer" />
        </Button>
      </Tooltip>
      {/* Spinner */}
      {loading && (
        <Spinner label="Baixando conteúdo" color="default" className="w-full" />
      )}

      {/* Table */}
      {!loading && <OrderListTable orders={pedidos} />}
    </div>
  );
};

export default Pedidos;
